import React, { useRef, useState } from "react";
import DaumPostcode from "react-daum-postcode";
import { toast } from "react-toastify";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";

import { IoSettingsOutline } from "react-icons/io5";
import { IoMdClose } from "react-icons/io";

import { CompanyFormContainer, CustomLabel, FormContainer } from "../../styled/setting";
import { AddrSearchModal } from "../../../../scheduler/component/styled/calendarEntry";

import InputField from "../common/form/inputField";
import MediaUpload from "../common/form/mediaUpload";
import CompanyPreview from "./companyPreview";

const CompanyForm = ({
  formData,
  setFormData,
  setModal,
  currentAuth,
  badges,
  addImages,
  deleteImages,
}) => {
  const [showPostCode, setShowPostCode] = useState(false);

  const openPostCode = () => {
    if (currentAuth === "VIEWER") {
      toast.error("수정 권한이 존재하지 않습니다.");
      return;
    }
    setShowPostCode(true);
  };
  const closePostCode = () => setShowPostCode(false);

  const changeInput = (e) => {
    // if (currentAuth === "VIEWER") {
    //   toast.error("수정 권한이 존재하지 않습니다.");
    //   return;
    // }

    const { name, value } = e.target;
    setFormData((data) => ({ ...data, [name]: value }));
  };

  // 카카오 주소
  const userAddress = (data) => {
    const extraAddress = [data.bname, data.buildingName].filter(Boolean).join(", ");
    const fullAddress = data.address + (extraAddress ? ` (${extraAddress})` : "");
    setFormData((data) => ({ ...data, addr: fullAddress }));

    closePostCode();
  };

  const tooltipData = {
    logoImage: [
      {
        title: "대표사진",
        description: "회사의 대표 이미지입니다.",
        example: "768 x 384 혹은 2:1 비율을 권장드립니다.",
      },
      {
        title: "여러 장 업로드 가능",
        description: "최대 5장까지 업로드할 수 있습니다.",
        example: "업로드한 이미지는 슬라이드 형식으로 순차 표시됩니다.",
      },
    ],
    cmpnyIntroduce: [
      {
        title: "추가 정보 입력",
        example: "혜택안내, 매장정보 등 추가 정보를 자유롭게 입력해주세요.",
      },
    ],
    hashTag: [
      {
        title: "해시태그",
        description: "해시태그는 검색 시 노출에 도움이 됩니다.",
        example: "무관한 키워드 입력 시 삭제될 수 있으니, 관련 있는 문구만 입력해 주세요.",
      },
    ],
    notice: [],
    originInfo: [{}],
  };

  const handleKeyDown = (e) => {
    const { tag, hashTag } = formData;
    const trimmedTag = tag.trim();

    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();

      if (hashTag.length >= 3) {
        toast.error("태그는 3개까지 등록 가능합니다.");
        return;
      }

      if (!!hashTag.includes(trimmedTag)) {
        toast.error("이미 존재하는 태그입니다.");
        return;
      }

      if (trimmedTag) {
        setFormData((data) => ({
          ...data,
          hashTag: [...data.hashTag, trimmedTag],
          tag: "",
        }));
      }
    }
  };

  const changeTag = (e) => {
    const { value } = e.target;
    setFormData((data) => ({ ...data, tag: value }));
  };

  const deleteTag = (index) => {
    setFormData((data) => ({
      ...data,
      hashTag: [...data.hashTag].filter((_, idx) => index !== idx),
    }));
  };

  const numericChange = (e) => {
    const { name, value } = e.target;
    setFormData((data) => ({ ...data, [name]: onlyNumber(value) }));
  };

  const inputFields = [
    {
      label: "회사명",
      name: "cmpnyNm",
      placeholder: "회사명을 입력해주세요.",
      onChange: changeInput,
    },
    {
      label: "업종",
      name: "cmpnySe",
      placeholder: "회사 업종을 입력해주세요.",
      onChange: changeInput,
    },
    {
      label: "연락처",
      name: "tel",
      placeholder: "연락처를 입력해주세요.",
      onChange: numericChange,
    },
    {
      label: "아이템",
      name: "item",
      placeholder: "판매 아이템을 입력해주세요.",
      onChange: changeInput,
    },
    {
      label: "해시태그",
      name: "tag",
      type: "text",
      placeholder: "태그를 입력한 후 엔터 키를 눌러주세요. (최대 3개)",
      onChange: changeTag,
      keyboardEvent: {
        onKeyDown: handleKeyDown,
      },
      tooltip: tooltipData.hashTag,
      children:
        formData.hashTag && formData.hashTag.length > 0 ? (
          <div className="tags">
            {formData.hashTag.map((tag, idx) => (
              <div>
                <span>{tag}</span>
                <button onClick={() => deleteTag(idx)}>
                  <IoMdClose />
                </button>
              </div>
            ))}
          </div>
        ) : null,
    },
  ];

  return (
    <CompanyFormContainer className="contents">
      <FormContainer>
        <MediaUpload
          keyName="cmpnyImage"
          label="대표 사진"
          max={5}
          media={formData.cmpnyImage}
          handleAddImage={addImages}
          handleDeleteImage={deleteImages}
          accept="image/*"
          tooltip={tooltipData.logoImage}
          isSlide={true}
        />
        {inputFields.map((field) => (
          <InputField
            key={field.name}
            value={formData[field.name]}
            // readOnly={currentAuth === "VIEWER"}
            {...field}
          />
        ))}
        <li className="adres">
          <span className="tit">주소</span>
          <div className="cont">
            <input
              type="text"
              name="addr"
              placeholder="주소찾기 버튼을 눌러주세요."
              value={formData.addr}
              readOnly
            />
            <input
              type="text"
              name="addrDetail"
              placeholder="상세주소를 입력해주세요."
              value={formData.addrDetail}
              onChange={changeInput}
              // readOnly={currentAuth === "VIEWER"}
            />
            <button onClick={() => openPostCode()}>주소찾기</button>
          </div>
        </li>

        <li className="badges">
          <span className="tit">혜택 선택</span>
          <div className="cont">
            <button className="setting" onClick={() => setModal("badge")}>
              혜택관리 <IoSettingsOutline />
            </button>
            <div>
              {(formData.cmpnyBadge || []).map((badge) => (
                <span>{badges[badge]}</span>
              ))}
            </div>
          </div>
        </li>
        <li>
          <div className="tit">상생매장여부</div>
          <div className="cont check">
            <CustomLabel>
              <input type="checkbox" checked={true} />
              <span className="checkmark"></span>
            </CustomLabel>
            <p>
              <span>상생매장이 아닐 경우 언제든지 해지될 수 있습니다.</span>
            </p>
          </div>
        </li>
      </FormContainer>
      <CompanyPreview formData={formData} />
      {showPostCode && (
        <AddrSearchModal
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closePostCode();
            }
          }}>
          <div className="modalContent">
            <DaumPostcode onComplete={userAddress} />
            <button onClick={closePostCode}>닫기</button>
          </div>
        </AddrSearchModal>
      )}
    </CompanyFormContainer>
  );
};

export default CompanyForm;
